import { cleanTimeout } from "@/utils/cleanTimeout.ts";
import { SECONDS } from "@warrenio/utils/timeUnits";
import { useStore } from "jotai/react";
import type { Atom } from "jotai/vanilla";
import { useEffect, useRef } from "react";

const PREFETCH_START_DELAY = 1.5 * SECONDS;
const PREFETCH_MOUNT_DURATION = 15 * SECONDS;

export function PreloadAtom({ atom }: { atom: Atom<any> }) {
    const store = useStore();

    const unsubscribeRef = useRef<() => void>(undefined);
    const cleanTimeoutRef = useRef<() => void>(undefined);

    useEffect(() => {
        cleanTimeoutRef.current = cleanTimeout(() => {
            console.debug("Prefetching...");

            // Subscribing to the atom causes the queries to be triggered
            unsubscribeRef.current = store.sub(atom, () => {});

            // Unsubscribe from the prefetch atom eventually to prevent unnecessary query auto-refresh later
            // (all mounted queries are periodically refreshed)
            cleanTimeoutRef.current = cleanTimeout(() => {
                unsubscribeRef.current?.();
                unsubscribeRef.current = undefined;

                cleanTimeoutRef.current = undefined;
            }, PREFETCH_MOUNT_DURATION);
        }, PREFETCH_START_DELAY);

        return () => {
            cleanTimeoutRef.current?.();
            unsubscribeRef.current?.();
        };
    }, [store, atom]);

    return null;
}
